import {ReactNode} from "react";
import {StyleSheet, View} from "react-native";

type Props = {
    children?: ReactNode;
}

export default function AvatarTable({children}: Props) {
    return (
        <View style={styles.table}>
            {children}
        </View>
    )
}

export const styles = StyleSheet.create({
    table: {
        width: "100%",
        borderRadius: 8,
        overflow: "hidden",
        marginBottom: 8,
    },
})